import React from "react"

export const Light = () => {
    return (
        <>
            <ambientLight />
            <pointLight position={[10, 10, 10]} />
        </>
    )
} 